import { render, staticRenderFns } from "./PartyOnboarding.vue?vue&type=template&id=6d065aff"
import script from "./PartyOnboarding.vue?vue&type=script&lang=js"
export * from "./PartyOnboarding.vue?vue&type=script&lang=js"
import style0 from "./PartyOnboarding.vue?vue&type=style&index=0&id=6d065aff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports